import TrainIcon from '@material-ui/icons/Train';

import SessionList from './list';
import SessionShow from './show';
import SessionEdit from './edit';

export default {
    list: SessionList,
    show: SessionShow,
    edit: SessionEdit,
    icon: TrainIcon
};